export default {
  '401': 'Authentication failed. Unable to access system resources.',
  '403': 'You do not have permission to perform the current operation.',
  '404': 'The accessed resource does not exist.',
  'default': 'Unknown system error. Please report to the administrator.'
}